<template>
  <div>
    <notice-list v-show="tabType === 1" @handleShow="handleShow" />
    <notice-show v-if="tabType === 2" :rowItem="rowItem" @handleShow="handleShow"/>
  </div>
</template>

<script>
import noticeList from './list.vue'
import noticeShow from './show.vue'
export default {
  components: { noticeList,noticeShow },
  data() {
    return {
      tabType: 1,
      rowItem: null,
      technicalState:null
    }
  },
  methods: {
    handleShow(row, type) {
      this.tabType=type
      this.rowItem = { ...row }
    }
  }
}
</script>

<style>
</style>
